export default __webpack_public_path__ + "static/media/favicon.0fc877c9.ico";